import { withForm } from '@brighte/brighte-one-core';
import withVisibility from '../core/hoc/withVisibility';
export default withVisibility({ level: 'field' })(withForm(() => null));
